import '../../style/base.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.28@vant/es/cell-group/style/index.js
// module id = xYeR
// module chunks = 10